<p-table [value]="this.appointments" dataKey="id" responsiveLayout="scroll">
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 3rem"></th>
      <th pSortableColumn="calendar">
        {{ "COMMON.SITE" | translate }}
        <p-sortIcon field="calendar"></p-sortIcon>
      </th>
      <th pSortableColumn="name">
        {{ "COMMON.DESCRIPTION" | translate }}
        <p-sortIcon field="name"></p-sortIcon>
      </th>
      <th>{{ "COMMON.CALENDAR" | translate }}</th>
      <th>{{ "COMMON.DATE" | translate }}</th>
      <th>{{ "COMMON.STATUS" | translate }}</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-appointment let-expanded="expanded">
    <tr>
      <td>
        <button
          type="button"
          pButton
          pRipple
          [pRowToggler]="appointment"
          class="p-button-text p-button-rounded p-button-plain"
          [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
        ></button>
      </td>
      <td>{{ appointment.calendar.site.name }}</td>

      <td>{{ appointment.name }}</td>

      <td>{{ appointment.calendar.name }}</td>

      <td>
        {{ moment(appointment.start).format("DD-MM-YYYY HH:mm") }} /
        {{ moment(appointment.end).format("HH:mm") }}
      </td>
      <td>
        <app-status [status]="appointment.status"></app-status>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="6">
        {{ "COMMON.TABLE.EMPTY.APPOINTMENTS" | translate }}
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="expandedrow" let-appointment>
    <tr>
      <td colspan="6">
        <p-table
          [style]="{ border: '2px solid ' + appointment.status.bgcolor }"
          [value]="appointment.treatments"
          styleClass="Table"
          dataKey="name"
        >
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="category">
                {{ "COMMON.CATEGORY" | translate }}
                <p-sortIcon field="category"></p-sortIcon>
              </th>
              <th pSortableColumn="name">
                {{ "COMMON.TREATMENT.NAME" | translate }}
                <p-sortIcon field="category"></p-sortIcon>
                <p-sortIcon field="name"></p-sortIcon>
              </th>

              <th pSortableColumn="price">
                {{ "COMMON.PRICE" | translate }}
                <p-sortIcon field="price"></p-sortIcon>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-treatment>
            <tr>
              <td>{{ treatment.treatment.category.name }}</td>
              <td>{{ treatment.treatment.name }}</td>
              <td>
                {{
                  treatment.price
                    | currency
                      : (treatment.currency?.code || 'EUR')
                      : "symbol-narrow"
                      : undefined
                      : this.translate.currentLang
                }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="5">
                {{ "COMMON.TABLE.EMPTY.APPOINTMENTS.TREATMENTS" | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </td>
    </tr>
  </ng-template>
</p-table>
